// extracted by mini-css-extract-plugin
module.exports = {"btnGreen":"styles_btnGreen__155_9","btnRed":"styles_btnRed__2fGC1","container":"styles_container__1wY_h","group":"styles_group__3gkpG","text":"styles_text__1vmvd"};